import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { resetFilters } from '../../actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCode, faPencilAlt } from '@fortawesome/free-solid-svg-icons';

const ToggleBar = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const isDev = useSelector(state => state.devMode);

    return (
        <div
            role="button" title="toggle between developer and designer portfolio's"
            className='toggle-bar-container'>
            <input
                type='checkbox'
                id='toggle-checkbox'
                className='hide'
                checked={!isDev}
                onChange={() => {
                    dispatch(resetFilters())
                    // navigate to the other portfolio; the route drives the mode + body class
                    navigate(isDev ? '/designer' : '/dev')
                }} />
            <label htmlFor='toggle-checkbox' className='toggle-bar'>
                <FontAwesomeIcon icon={faCode} />
                <FontAwesomeIcon icon={faPencilAlt} />
                <div className='ball'></div>
            </label>
        </div>

    );
}

export default ToggleBar;